import { Select } from "@primer/react";
import { apiClient } from "../apiClient";
import { IKeHoachThucTapDoanhNghiep } from "../../model/response/xet-thuc-tap/IKeHoachThucTapDoanhNghiep";

const KE_HOACH_THUC_TAP_DOANH_NGHIEP_ENDPOINT = 'ke-hoach-thuc-tap-doanh-nghiep';
export const keHoachThucTapDoanhNghiepApi = {
    SelectByDotThucTap: (id_dot_thuc_tap: number) => apiClient.get(`${KE_HOACH_THUC_TAP_DOANH_NGHIEP_ENDPOINT}/dot-thuc-tap/${id_dot_thuc_tap}`),
    Insert: (data: IKeHoachThucTapDoanhNghiep) => apiClient.post(`${KE_HOACH_THUC_TAP_DOANH_NGHIEP_ENDPOINT}`, data),
    Update: (id: number, data: IKeHoachThucTapDoanhNghiep) => apiClient.put(`${KE_HOACH_THUC_TAP_DOANH_NGHIEP_ENDPOINT}/${id}`, data),
    Delete: (id: number) => apiClient.delete(`${KE_HOACH_THUC_TAP_DOANH_NGHIEP_ENDPOINT}/${id}`),
}